import { Tab, FolderOpenIcon } from 'evergreen-ui';

const SectionList = ({ sections, selectedSection, onSelectSection, userRole }) => {

    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
            {sections
                .filter((section) => userRole !== 'educatore' || section.is_visible_to_educators)
                .map((section) => (
                    <Tab
                        key={section.id}
                        isSelected={selectedSection === section.id}
                        onSelect={() => onSelectSection(section.id)}
                        style={{ marginRight: 8 }}
                    >
                        <FolderOpenIcon marginRight={4} />
                        {section.name} {userRole !== 'educatore' && section.is_visible_to_educators && '(e)'}
                    </Tab>
                ))}
        </div>
    );
};

export default SectionList;